export interface ApplicationConfig {
  coBorrowersCount: number;
}

const applicationConfig: ApplicationConfig = {
  coBorrowersCount: 3,
};

export default applicationConfig;
